import { httpBus } from "@/api/index.js";

// 新增 Galaxy（集中式储能根节点，v3 接口）
export const addGalaxy = data => {
  return httpBus.request("post", "/device/v3/galaxy", { data });
};

// 编辑 Galaxy（集中式储能根节点，v3 接口）
export const updateGalaxy = data => {
  return httpBus.request("put", "/device/v3/galaxy", { data });
};

// 集中式：按电站查询 Galaxy 树
export const getGalaxyTree = stationId => {
  return httpBus.request("get", "/device/v3/galaxy/tree", { params: { stationId } });
};

// 集中式：删除 Galaxy
export const deleteGalaxy = equipmentId => {
  return httpBus.request("delete", `/device/v3/galaxy/${equipmentId}`);
};
